import { motion } from "framer-motion";
import { IoIosArrowBack } from "react-icons/io";
import CustomInput from '../../../../Modals/filter modal/Input'
import CargoService from "../../../../services/Cargo";
import { useEffect, useState } from "react";
import { data } from "react-router";

export default function Step1({ formData, setFormData, errors, shake, setCurrentStep }) {
  const container = {
    hidden: { opacity: 0, y: 8 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.08,
        when: "beforeChildren",
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 6 },
    show: { opacity: 1, y: 0 },
  };

  const [Data, SetOriginData] = useState([]);

  const [loadingCity, setLoadingCity] = useState(false);

 
  async function getAllCityAndState() {
    try {
      setLoadingCity(true);


      const res = await CargoService.getAllState();
      const states = res?.data?.data ?? [];

      const fetches = states.map((st) =>
        CargoService.getAllCity({ state_id: st._id })
          .then((r) => ({ state: st, citiesRes: r }))
          .catch((err) => {
            console.error("city fetch error for", st, err);
            return { state: st, citiesRes: null };
          })
      );

      const results = await Promise.all(fetches);
      const provincesWithCitiesArr = results.map(({ state, citiesRes }) => {
        const stateId = state?._id ?? state?.id ?? null;
        const stateName = state?.name ?? state?.title ?? String(stateId ?? "");

        const citiesArray = citiesRes?.data?.data ?? citiesRes?.data ?? citiesRes ?? [];


        const citiesNormalized = (Array.isArray(citiesArray) ? citiesArray : []).map((c) => {
          if (typeof c === "string") {
            return { name: c, value: c };
          }
          const cityId = c?._id ?? c?.id ?? c?.city_id ?? null;
          const cityName = c?.name ?? c?.title ?? c?.city_name ?? String(cityId ?? "");
          return { name: cityName, value: cityId ?? cityName };
        });

        return {

          label: stateName,
          value: stateId,
          subItems: citiesNormalized,
        };
      });

      SetOriginData(provincesWithCitiesArr);
      console.log("Provinces with citiesssss:", provincesWithCitiesArr);
    }
    catch (err) {
      console.error("getAllCityAndState error:", err);

    } finally {
      setLoadingCity(false);
    }
  }

  useEffect(() => {
    getAllCityAndState();
  }, []);

  //car data
  const [carData, setCarData] = useState([])

  async function getAllCar() {
    try {

      const res = await CargoService.getAllCarType()
      const ids = res?.data?.data?.map((it) => { return it._id })
      const name = res?.data?.data?.map((it) => { return it?.label + "-" + it.name })

      setCarData(ids?.map((it, index) => { return { value: it, label: name[index] } }))

    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getAllCar();
  }, []);

  console.log("dataformm:", formData)

  return (
    <motion.section
      className={`flex justify-start items-start flex-col gap-5 max-w-6xl w-full mx-auto ${shake ? "animate-shake" : ""
        }`}
      variants={container}
      initial="hidden"
      animate="show"
      exit="hidden"
      dir="rtl"
    >
      {/* هدر */}
      <motion.div
        variants={item}
        className="flex flex-row justify-between w-full h-max"
      >
        <img
          className="w-[80px] object-contain"
          src="/icon-512.png"
          alt="logo"
        />
      </motion.div>

      {/* متن توضیح */}
      <motion.p
        variants={item}
        className="block text-gray-500 text-sm lg:w-1/2 w-full leading-relaxed"
      >
        برای ثبت آگهی جدید نیاز به اطلاعاتی جهت ارائه خدمات بهتر برای ثبت بار به شما داریم
        <br />
        قابل توجه شما : تضمین حفظ اطلاعات شما با بارسرا می باشد !
      </motion.p>

      {/* تیتر بخش */}
      <motion.div
        variants={item}
        className="flex flex-row justify-start items-center gap-5 h-max w-full"
      >
        <div className="h-[40px] w-[10px] rounded-lg bg-special" />
        <p className="text-gray-500 text-md lg:text-2xl font-bold">
          لطفا جهت ثبت آگهی در بارسرا اطلاعات خود را تکمیل کنید
        </p>
      </motion.div>

      {/* Row 1 */}
      <motion.div variants={item} className="grid sm:flex sm:flex-wrap gap-8 w-full">

        {/* عنوان */}
        <CustomInput
          label="عنوان"
          type="textarea"
          val={formData.title}
          setVal={(v) => setFormData({ ...formData, title: v })}
          error={errors.title}
        />



        {/* مدل */}
        <CustomInput
          label="مدل"
          type="option"
          val={formData.model}
          setVal={(v) => setFormData({ ...formData, model: v })}
          error={errors.model}
          items={carData}
        />

        {/* سال تولید */}
        <CustomInput
          label="سال تولید"
          type="option"
          val={formData.year}
          setVal={(v) => setFormData({ ...formData, year: v })}
          items={Array.from({ length: 31 }, (_, i) => {
            const year = 1375 + i;
            return { label: String(year), value: String(year) };
          })}
          error={errors.year}
        />


        {/* نوع معامله */}
        <CustomInput
          label="نوع معامله"
          type="option"
          val={formData.dealType}
          setVal={(v) => setFormData({ ...formData, dealType: v })}
          items={[
            { label: "فروش", value: "فروش" },
            { label: "اجاره‌", value: "اجاره‌" },
          ]}
          error={errors.dealType}
        />


        {/* رنگ */}
        {/* <CustomInput
          label="رنگ"
          type="textarea"
          val={formData.color}
          setVal={(v) => setFormData({ ...formData, color: v })}
          error={errors.color}
        /> */}

        {/* شهر */}
          {/* <CustomInput
            label="شهر"
            type="option"
            val={formData.city}
            setVal={(v) => setFormData({ ...formData, city: v })}
            error={errors.city}
            items={Data}
          /> */}

        {/* شهر */}
        <CustomInput
          label="شهر"
          type="option"
          val={formData.city}
          // main value is state id; sub value (setSubVal) is the city id
          setVal={(v) => setFormData({ ...formData, state: v })}
          setSubVal={(v) => setFormData({ ...formData, city: v })}
          error={errors.city}
          items={Data}
        />

        {/* قیمت */}
        <CustomInput
          label="قیمت"
          type="number"
          val={formData.price}
          setVal={(v) => setFormData({ ...formData, price: v })}
          unitLabel="تومان"
          error={errors.price}
        />


      </motion.div>

      {/* Row 2 */}
      <motion.div variants={item} className="grid grid-cols-1 sm:flex sm:flex-wrap gap-8 w-full">

      </motion.div>

      {/* آدرس */}
      {/* <motion.div variants={item} className="flex flex-col w-full sm:w-3/5">
        <label className="text-lg text-gray-600 mb-1 text-right">
          آدرس
        </label>
        <textarea
          value={formData.address || ""}
          onChange={(e) =>
            setFormData({ ...formData, address: e.target.value })
          }
          placeholder="آدرس کامل را وارد کنید..."
          rows={4}
          className={`rounded-2xl border px-3 py-2 text-sm focus:ring-2 focus:outline-none w-full ${errors.address
            ? "border-red-500 focus:ring-red-500"
            : "border-gray-300 focus:ring-special"
            }`}
        />
        {errors.address && (
          <span className="text-red-500 text-xs mt-1">{errors.address}</span>
        )}
      </motion.div> */}

      {/* توضیح */}
      <motion.div variants={item} className="flex flex-col w-full sm:w-3/5">
        <label className="text-lg text-gray-600 mb-1 text-right">
          توضیح
        </label>
        <textarea
          value={formData.description || ""}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          placeholder="توضیحات کامل را وارد کنید..."
          rows={4}
          className="rounded-2xl border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-special focus:outline-none w-full"
        />
      </motion.div>



    </motion.section>
  );
}
